import React from "react";
import styled from "styled-components";
import DomeHeader from "../components/DomeHeader";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { DomeText, Header2, Header5, Header6 } from "../components/typography";
import richText from "../utils/richText";

const Wrapper = styled.div`
  padding: 64px 32px;
  background: ${Colors.cream3};

  ${Header2} {
    margin: 24px auto 40px;
    max-width: 800px;

    color: ${Colors.grey};
    text-align: center;

    @media ${Breakpoints.desktop} {
      margin: 24px auto 80px;
    }
  }

  > div:last-child div:first-child {
    ${DomeText} {
      text-align: center;
      display: block;
      color: ${Colors.greyLight};
    }

    ${Header6} {
      color: ${Colors.hunter};
      text-align: center;

      margin: 8px 0 40px;
    }
  }

  @media ${Breakpoints.tablet} {
    > div:last-child div:first-child {
      ${DomeText}, ${Header6} {
        text-align: left;
      }
    }
  }
`;

const Items = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;

  @media ${Breakpoints.desktop} {
    width: 70%;
  }

  .item {
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px 20px;
      margin-bottom: 30px;

      @media ${Breakpoints.desktop} {
        width: 25%;
        margin: 0;
      }

      img {
          width: 100px;
          margin-bottom: 20px;
      }

      ${Header5} {
        color: ${Colors.darkGrey};
      }

      p {
          color: ${Colors.medGrey};
      }
  }
`

export default function CalloutList({ headline, eyebrow, items }) {
  return (
    <Wrapper>
      {eyebrow && <DomeHeader text={eyebrow} centered />}
      {headline && <Header2>{headline}</Header2>}
      
      <Items>
          {items.map((item, index) => (
            <div className="item" key={index}>
              <img src={ item.image.file.url } alt="" />
              <Header5>{item.title}</Header5>
              <p>{ richText(item.text.raw) }</p>
            </div>
          ))}
      </Items>
    </Wrapper>
  );
}
